import React, { useState, useEffect, useReducer } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom'
import _ from 'lodash'
import Header from '../../header/Header'
import Footer from '../../footer/Footer'
import { Button } from 'devextreme-react/button';
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import TextArea from 'devextreme-react/text-area';
import { TagBox } from 'devextreme-react/tag-box';
import NumberBox from 'devextreme-react/number-box';
import DateBox from 'devextreme-react/date-box';
import { CheckBox } from 'devextreme-react/check-box';
import { Validator, RequiredRule } from 'devextreme-react/validator';
import kaizenReducer from '../../../reducers/kaizen';
import * as action from '../../../actions/kaizen';
import ScrollView from 'devextreme-react/scroll-view';
import { KAIZENCONFIG } from '../config';
import FileUploader from 'devextreme-react/file-uploader';
import { openFileToView, onDownloadFile } from '../../../common/utils';

const initialKaizenState = { kaizenCategories: [], kaizenArea: [], kaizenCell: [], userData: null, allUsers: [], saveSuccess: false, kaizenData: null }
const initialCIData = { actionTaken: null, approvalStatus: null, approverEid: null, archive: null, assignedTo: null, assignedToCheck: null, category: null, completedDate: null, costImpact: null, created: null, createdDate: null, dueDate: null, goDo: null, id: 0, kaizenIdea: null, kaizenTitle: null, lines: null, location: null, managerApproval: null, managerEid: null, module: null, proposer: null, proposerEid: null, proposersDepartment: null, recognition: null, recognizedKaizen: null, siteCode: null, sqdcpApprover: null, status: null, tierId: null, transferability: null, ttiApprover: null, ttiCategory: null, collaborators: [] }
/*const attachmentsList = [{ name: "image1.jpg", isDeleted: false }, { name: "image2.jpg", isDeleted: false }]*/
const RaiseCI = props => {
    const { category, site, kaizenId, query } = useParams();
    const [animate, setAnimate] = useState('');
    const [state, dispatch] = useReducer(kaizenReducer, initialKaizenState)
    const { allUsers, userData, kaizenData } = state
    const [ciData, setCIData] = useState({ ...initialCIData })
    const [isDisable, setIsDisable] = useState(false);
    const [isApprovalDisable, setIsApprovalDisable] = useState(false);
    const navigate = useNavigate();
    const [distinctUsers, setDistinctUsers] = useState([])


    useEffect(() => {
    }, [distinctUsers, ciData.collaborators]);

    useEffect(() => {
        let kaizenDetails = {
            'id': parseInt(kaizenId),
            'siteCode': site
        }
        action.fetchKaizenDataById(dispatch, kaizenDetails);
        action.fetchKaizenUserData(dispatch);
        action.fetchKaizenAllUsers(dispatch);
    }, [kaizenId])

    useEffect(() => {
        if (kaizenData) {
            setCIData({ ...ciData, ...kaizenData });

            if (userData) {
                if (userData?.hId !== kaizenData?.approverEid) {
                    setIsApprovalDisable(true);
                }
            }
            if (kaizenData?.goDo === 'TRUE') {
                if (kaizenData?.status !== 'In Progress')
                    setIsDisable(true);
            }
            else if (kaizenData?.goDo === 'FALSE') {
                if ((kaizenData?.approvalStatus && kaizenData?.approvalStatus !== 'Approved')
                    || !kaizenData?.approvalStatus)
                    setIsDisable(true);
            }
            if (allUsers.length > 0 && userData) {
                populateDistinctUsersList();
            }
        }
    }, [kaizenData, allUsers, userData])

    const populateDistinctUsersList = () => {
        let modifiedUsersList1 = [];
        if (kaizenData?.assignedTo.length > 1) {
            let _splitedData = kaizenData?.assignedTo.split(';');
            (_splitedData.length > 1)
                ? _splitedData.map(collab => modifiedUsersList1.push(collab))
                : modifiedUsersList1.push(kaizenData?.assignedTo);

            ciData.collaborators = modifiedUsersList1;
        }
        let modifiedUsersList = allUsers.map(ele => { return { ...ele, value: ele.employeeName + ":" + ele.employeeId } })
        let _distinctUsers = [...new Map(modifiedUsersList.map(ele => [ele["employeeId"], ele])).values(),];
        let _distUsersExclPropser = _distinctUsers.filter(ele => ele.employeeId.toUpperCase() !== userData.hId.toUpperCase())
        setDistinctUsers([..._distUsersExclPropser])
        setCIData({ ...ciData })
    }
    useEffect(() => {
        setTimeout(() => {
            setAnimate('animate')
        }, 250);
    }, []);

    const scrollConfig = {
    }
    const handleBack = () => {
        navigate(`/siteApp/${category}/${site}/kaizen/cilist/${query}`)
    }
    //const handleSave = () => {
    //    if (ciData.status) {
    //        ciData.assignedTo = ciData.collaborators.join(';');
    //        action.updateKaizenRaiseCI(dispatch, ciData)
    //        handleBack();
    //    } else {
    //        alert("Not Valid Details");
    //        handleBack();
    //    }
    //}

    const handleSave = async () => {
        if (ciData.status) {
            ciData.assignedTo = ciData.collaborators.join(';');
            let _updatedAttachmentList = [...attachments.filter(ele => !ele.isDeleted).map(ele => ele.name), ...selectedFiles.map(ele=>ele.name)]
            let _ciData = { ...ciData }
            //attachment: _updatedAttachmentList.join(",")

            let formData = new FormData();
            formData.append('actionTaken', _ciData.actionTaken)
            formData.append('approvalStatus', _ciData.approvalStatus)
            formData.append('approverEid', _ciData.approverEid)
            formData.append('archive', _ciData.archive)
            formData.append('assignedTo', _ciData.assignedTo)
            formData.append('assignedToCheck', _ciData.assignedToCheck)
            formData.append('category', _ciData.category)
            formData.append('completedDate', _ciData.completedDate)
            formData.append('costImpact', _ciData.costImpact)
            formData.append('created', _ciData.created)
            formData.append('createdDate', _ciData.createdDate)
            formData.append('dueDate', _ciData.dueDate)
            formData.append('goDo', _ciData.goDo)
            formData.append('id', _ciData.id)
            formData.append('kaizenIdea', _ciData.kaizenIdea)
            formData.append('kaizenTitle', _ciData.kaizenTitle)
            formData.append('lines', _ciData.lines)
            formData.append('location', _ciData.location)
            formData.append('managerApproval', _ciData.managerApproval)
            formData.append('managerEid', _ciData.managerEid)
            formData.append('module', _ciData.module)
            formData.append('proposer', _ciData.proposer)
            formData.append('proposerEid', _ciData.proposerEid)
            formData.append('proposersDepartment', _ciData.proposersDepartment)
            formData.append('recognition', _ciData.recognition)
            formData.append('recognizedKaizen', _ciData.recognizedKaizen)
            formData.append('siteCode', _ciData.siteCode)
            formData.append('sqdcpApprover', _ciData.sqdcpApprover)
            formData.append('status', _ciData.status)
            formData.append('tierId', _ciData.tierId)
            formData.append('transferability', _ciData.transferability)
            formData.append('ttiApprover', _ciData.ttiApprover)
            formData.append('ttiCategory', _ciData.ttiCategory)
            formData.append('collaborators', _ciData.collaborators)
            formData.append('recognizedByManager', _ciData.recognizedByManager)
            formData.append('attachment', _ciData.attachment)

            if (selectedFiles.length > 0 ) {
                selectedFiles.forEach((file) => {
                    formData.append('files', file);
                });
            }
            
           action.updateKaizenRaiseCI(dispatch, formData)
            handleBack();
        } else {
            alert("Not Valid Details");
            handleBack();
        }
    }


    const handleInputChange = (e) => {
        let name = e.component.option('name')
        let value = e.value
        if (e.event) {
            if (name === "approvalStatus") {
                switch (value) {
                    case 'Approved':
                        setCIData({ ...ciData, [name]: value, status: "In Progress" })
                        break;
                    case 'Rejected':
                        setCIData({ ...ciData, [name]: value, status: "Rejected" })
                        break;
                    default:
                        setCIData({ ...ciData, [name]: value, status: "Pending Approval" })
                        break;
                }
            }
            else {
                setCIData({ ...ciData, [name]: value })
            }
        }
    }

    const [attachments, setAttachments] = useState([])

    useEffect(() => {
        if (kaizenData) {
            if (kaizenData.attachment) {
                let _attachmentList = kaizenData.attachment.split(",").map(ele => { return { name: ele, isDeleted: false } })
                setAttachments(_attachmentList)
            }
        }
    }, [kaizenData])

    const handleDeleteAttachment = (id) => {
        let updatedAttachmentsList = attachments.map((ele, index) => index === id ? { ...ele, isDeleted: !ele.isDeleted } : ele)
        setAttachments(updatedAttachmentsList)
    }

    const [selectedFiles, setSelectedFiles] = useState([])
    const handleSelectAttachments = (e) => {
        setSelectedFiles(e.value)
    }

    return (
        <>
            <Header showPinBtn={false} site={[]} />
            <section className="page-content">
                <div className="site-view tier-wrap admin-console-wrapper">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb">
                            <span className="icon icon-corporate"></span>
                            <ul>
                                <li><Link to={`/home/${category}`}>Home</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizen/cilist/${query}`}>Kaizen</Link></li>
                                <li><b>Edit CI</b></li>
                            </ul>
                        </div>

                        <div className="raiseci-section">
                            <div className="page-heading">
                                <h2>Edit CI</h2>
                            </div>
                            <div>
                                <Button
                                    text="Save"
                                    icon="save"
                                    type="success"
                                    stylingMode="contained"
                                    useSubmitBehavior={true}
                                    onClick={handleSave}
                                    visible={kaizenData?.status === 'Completed' || (isApprovalDisable && isDisable) ? false : true}

                                />
                                &nbsp; &nbsp;
                                <Button
                                    text="Cancel"
                                    stylingMode="contained"
                                    onClick={handleBack}
                                />
                            </div>
                        </div>
                        {
                            kaizenData &&
                            <ScrollView {...scrollConfig} style={{ height: "80%" }}>
                                <div className="raiseci-cards-section">
                                    <div className="raiseci-card">
                                        <div className="raiseci-card-form">
                                            <div className="raiseci-card-form-title" style={{ backgroundColor: '#1792E5' }}>
                                                <div>
                                                    <i className="dx-icon-tips" style={{ fontSize: "1.75rem" }}></i>
                                                </div>
                                                <div>
                                                    <b>Tell Us About Your Idea</b>
                                                </div>
                                            </div>
                                            <div className="raiseci-card-form-fields">
                                                <TextBox
                                                    id="idea"
                                                    name="idea"
                                                    labelMode={"floating"}
                                                    label='Kaizen Idea *'
                                                    value={kaizenData?.kaizenTitle}
                                                    disabled={true}
                                                />
                                                <TextBox
                                                    id="category"
                                                    name="category"
                                                    labelMode={"floating"}
                                                    label='Category *'
                                                    value={kaizenData?.category}
                                                    disabled={true}
                                                />
                                                <TextArea
                                                    name="description"
                                                    labelMode={"floating"}
                                                    label='Description *'
                                                    value={kaizenData?.kaizenTitle}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="editci-card-form">
                                            <div className="raiseci-card-form-title" style={{ backgroundColor: '#1792E5' }}>
                                                <div>
                                                    <i className="dx-icon-rename" style={{ fontSize: "1.75rem" }}></i>
                                                </div>
                                                <div className="raiseci-card-info">
                                                    <b> Approvals </b>
                                                </div>
                                            </div>
                                            <div className="raiseci-card-form-fields">
                                                <SelectBox
                                                    name="approvalStatus"
                                                    dataSource={KAIZENCONFIG.LOOKUPAPPROVALSTATUSCONFIG}
                                                    labelMode={"floating"}
                                                    label='Approval Status *'
                                                    value={ciData?.approvalStatus}
                                                    disabled={kaizenData?.status === 'Completed' || (isApprovalDisable && query === 'mykaizens') ? true : false}
                                                    onValueChanged={handleInputChange}
                                                >
                                                    <Validator>
                                                        <RequiredRule message="Approval is required" />
                                                    </Validator>
                                                </SelectBox>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="raiseci-card">
                                        <div className="raiseci-card-form">
                                            <div className="raiseci-card-form-title" style={{ backgroundColor: '#1380CA' }}>
                                                <div>
                                                    <i className="dx-icon-map" style={{ fontSize: "1.75rem" }}></i>
                                                </div>
                                                <div>
                                                    <b>Where is it ?</b>
                                                </div>
                                            </div>
                                            <div className="raiseci-card-form-fields">
                                                <TextBox
                                                    id="location"
                                                    name="location"
                                                    labelMode={"floating"}
                                                    label='Area *'
                                                    value={kaizenData?.location}
                                                    disabled={true}
                                                />
                                                <TextBox
                                                    id="module"
                                                    name="module"
                                                    labelMode={"floating"}
                                                    label='Cell *'
                                                    value={kaizenData?.module}
                                                    disabled={true}
                                                />

                                                <TextBox
                                                    id="lines"
                                                    name="lines"
                                                    labelMode={"floating"}
                                                    label='Lines *'
                                                    value={kaizenData?.lines}
                                                    disabled={true}
                                                />
                                                <NumberBox
                                                    name="savings"
                                                    labelMode={"floating"}
                                                    label='Potential yearly savings($)'
                                                    value={kaizenData.costImpact}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="editci-card-form">
                                            <div className="raiseci-card-form-title" style={{ backgroundColor: '#1380CA' }}>
                                                <div>
                                                    <i className="dx-icon-rename" style={{ fontSize: "1.75rem" }}></i>
                                                </div>
                                                <div className="raiseci-card-info">
                                                    <b> Kaizen Information </b>
                                                </div>
                                            </div>
                                            <div className="raiseci-card-form-fields">
                                                <SelectBox
                                                    name="status"
                                                    dataSource={KAIZENCONFIG.LOOKUPKAIZENSTATUSCONFIG}
                                                    labelMode={"floating"}
                                                    label='Kaizen Status *'
                                                    value={ciData.status}
                                                    disabled={isDisable}
                                                    onValueChanged={handleInputChange}
                                                >
                                                    <Validator>
                                                        <RequiredRule message="Category is required" />
                                                    </Validator>
                                                </SelectBox>
                                                <div>
                                                    Reusability
                                                    &nbsp;
                                                    <CheckBox
                                                        name="transferability"
                                                        labelMode={"floating"}
                                                        label='Reusability *'
                                                        defaultValue={false}
                                                        onValueChanged={handleInputChange}
                                                        disabled={ciData.status === 'Completed' || isDisable ? true : false}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="raiseci-card">
                                        <div className="raiseci-card-form">
                                            <div className="raiseci-card-form-title" style={{ backgroundColor: '#1792BC' }}>
                                                <div>
                                                    <i className="dx-icon-group" style={{ fontSize: "1.75rem" }}></i>
                                                </div>
                                                <div>
                                                    <b>Who is involved ?</b>
                                                </div>
                                            </div>
                                            <div className="raiseci-card-form-fields">
                                                <TextBox
                                                    name="proposer"
                                                    labelMode={"floating"}
                                                    label='Proposer *'
                                                    disabled={true}
                                                    value={userData?.employeeName}
                                                />
                                                <div>
                                                    Go Do
                                                    &nbsp;
                                                    <CheckBox
                                                        name="goDo"
                                                        value={kaizenData?.goDo === 'TRUE' ? true : false}
                                                        disabled={true}
                                                    />
                                                    &nbsp;
                                                    &nbsp;
                                                    &nbsp;
                                                    {kaizenData?.goDo === 'TRUE' ? "No Approval Required" : "Manager Approval required"}
                                                </div>
                                                <TagBox
                                                    style={{ "width": "100%" }}
                                                    name="collaborators"
                                                    labelMode={"floating"}
                                                    label='Collaborated With'
                                                    displayExpr="employeeName"
                                                    valueExpr="value"
                                                    acceptCustomValue={true}
                                                    className="dx-field-value"
                                                    items={distinctUsers}
                                                    showSelectionControls={true}
                                                    maxDisplayedTags={4}
                                                    showMultiTagOnly={false}
                                                    searchEnabled={true}
                                                    selectAllMode="allPages"
                                                    value={ciData.collaborators}
                                                    onValueChanged={handleInputChange}
                                                    disabled={kaizenData.status.status === 'Completed' || isDisable ? true : false}
                                                >
                                                </TagBox>
                                                <DateBox
                                                    name="dueDate"
                                                    labelMode={"floating"}
                                                    label='Due Date'
                                                    disabled={kaizenData.status.status === 'Completed' || isDisable ? true : false}
                                                    onValueChanged={handleInputChange}
                                                    value={ciData?.dueDate}
                                                />
                                                {attachments.length > 0
                                                    &&
                                                    <div >
                                                        <span><u>Attachments</u></span>
                                                    </div>
                                                }
                                                {attachments.map((ele, index) =>
                                                    <div key={index} style={{ display: "flex", gap: "1rem", alignItems: "center",  padding: "0 1rem" }}>
                                                        <a style={{ cursor: 'pointer', wordBreak: 'break-all' }} className="clickable-hover" onClick={() => openFileToView({ imageName: ele.name }, 'Kaizen&flag=true')}>
                                                            {ele.name}
                                                        </a>
                                                        <>
                                                            {/*!(kaizenData?.status === 'Completed' || (isApprovalDisable && isDisable))
                                                                &&
                                                                <i title="Delete" className= "fas fa-trash pointer" style={{ color: "red" }} onClick={() => handleDeleteAttachment(index)} />
                                                            */}
                                                            <i title="Download" className="fa fa-download pointer" onClick={() => onDownloadFile(ele.name,`Kaizen&flag=true`)} />
                                                        </>
                                                    </div>

                                                )}

                                                    <div >
                                                    <FileUploader
                                                        selectButtonText="Add Attachments"
                                                        uploadMode="useForm"
                                                        multiple={true}
                                                        accept="*"
                                                        labelText="Max. File Size 4 MB"
                                                        maxFileSize={4000000}
                                                        onValueChanged={handleSelectAttachments}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="editci-card-form">
                                            <div className="raiseci-card-form-title" style={{ backgroundColor: '#1792BC' }}>
                                                <div>
                                                    <i className="dx-icon-checklist" style={{ fontSize: "1.75rem" }}></i>
                                                </div>
                                                <div className="raiseci-card-info">
                                                    <b> Solution/Comments </b>
                                                </div>
                                            </div>
                                            <div className="raiseci-card-form-fields">
                                                <TextArea
                                                    name="actionTaken"
                                                    labelMode={"floating"}
                                                    label='Action Taken *'
                                                    value={ciData?.actionTaken}
                                                    onValueChanged={handleInputChange}
                                                    disabled={kaizenData.status === 'Completed' || isDisable ? true : false}
                                                >
                                                    <Validator>
                                                        <RequiredRule message="Action Taken is required" />
                                                    </Validator>
                                                </TextArea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ScrollView>
                        }
                    </div>
                </div>
            </section>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Footer showThemeSwitch={true} container="admin-console" hideSiteCount={true} activeSites={[]} sbg={[]} />
            </div>
        </>
    )
};
export default RaiseCI